<template>
  <div>Products</div>
</template>

<script>
export default {};
</script>

<style></style>
